import React, {useEffect, useState} from 'react';
import {Form} from '@ui/Form';
import {TextArea} from '@ui/TextArea';
import {ButtonSecondary, ButtonPrimary} from '@ui/Button';
import {handleError} from '@store/app.slice';
import {ReactComponent as CheckFeedbackIcon} from '@icons/CheckFeedback.svg';
import {useAppDispatch} from '@hooks/app';
import {FeedbackProps} from './types';
import styles from './FeedbackModal.module.scss';


export const FeedbackModal = ({onClose}: FeedbackProps) => {
    const [sent, setSent] = useState(false);
    const dispatch = useAppDispatch();

    if (sent) {
        return (
            <div className={styles.feedbackModal}>
                <div className={styles.feedbackThanksCenter}>
                    <CheckFeedbackIcon className={styles.successIcon}/>

                    <p className="text-h1 text-center mb-6">Отзыв отправлен</p>

                    <p className={styles.desc}>Мы рассмотрим ваши пожелания</p>

                    <ButtonSecondary className={styles.Btn} onClick={onClose}>
                        Закрыть
                    </ButtonSecondary>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.feedbackModal}>
            <p className='text-h1'>Обратная связь</p>
            <p className={styles.desc}>
                Ваше мнение об удобстве сервиса, пожелания по доработкам и функционалу
            </p>

            <Form
                action="/report/feedback"
                method="post"
                beforeSubmit={(values) => {
                    debugger;
                    const comment = values?.comment;

                    if (!comment) {
                        dispatch(handleError({message: 'Введите сообщение'} as any));
                        return {...values, comment};
                    }

                    return {
                        comment
                    };
                }}
                afterSubmit={(resp) => {
                    setSent(true);
                }}
            >
                <div className={styles.feedbackField}>
                    <TextArea name="comment" title="" rows={6}/>
                </div>
                <div className={styles.feedbackActions}>
                    <ButtonPrimary type="submit" className={styles.Btn}>
                        Отправить отзыв
                    </ButtonPrimary>
                </div>
            </Form>
        </div>
    );
};
